import { CustomCardColorBar, CustomPanel, PageHeader, PontuacaoCard } from '../../../../components'
import React from 'react'
import { azul, laranja, verde } from '../../../../assets/js/colors'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'

function EtapaEnvioRota({ history }) {
  const etapaEnvioParaRotaInfo = history.location.state.etapa_envio_para_rota_info

  const { pontuacao_total, pontuacao_obtida, tp_name, envio_rota_info } = etapaEnvioParaRotaInfo

  // Helpers
  const getTotalVeiculosCarregados = () => {
    return envio_rota_info.reduce((total, item) => total + item.qte_total_veiculos_carregados, 0)
  }

  const getQteVeiculosParados = () => {
    return envio_rota_info.reduce((total, item) => total + item.qte_veiculos_parados, 0)
  }

  const getQteVeiculosParadosAhMais02Dias = () => {
    return envio_rota_info.reduce((total, item) => total + item.qte_veiculos_parados_mais_2dias, 0)
  }

  // Render
  return (
    <>
      <PageHeader>
        Status Operação - &nbsp; <strong>Etapa Envio Veículos para Rota</strong>
      </PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-9">
              <h2>{tp_name}</h2>
            </div>
            <div className="p-col-3">
              <PontuacaoCard pontuacaoTotal={pontuacao_total} pontuacaoObtida={pontuacao_obtida} />
            </div>
            <div className="p-col-12">
              <EnvioParaRotaInfo
                envioParaRotaInfo={envio_rota_info}
                totalVeiculosCarregados={getTotalVeiculosCarregados()}
                qteVeiculosParados={getQteVeiculosParados()}
                qteVeiculosParadosMais02Dias={getQteVeiculosParadosAhMais02Dias()}
              />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function EnvioParaRotaInfo({
  envioParaRotaInfo,
  totalVeiculosCarregados,
  qteVeiculosParados,
  qteVeiculosParadosMais02Dias,
}) {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Envio Para Rota - Veículos de Entregas Parados</PageHeader>
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={azul}
          value={totalVeiculosCarregados}
          title={'Total de Veículos Carregados'}
          subTitle={'Total de Veículos Carregados no Período'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={verde}
          value={qteVeiculosParados}
          title={'Qte Veículos Parados'}
          subTitle={'Qte veículos NÃO enviados para rota - Parados'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={laranja}
          value={qteVeiculosParadosMais02Dias}
          title={'Qte Parados + 2 dias'}
          subTitle={'Qte de veículos parados par MAIS de 02 dias'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={envioParaRotaInfo} emptyMessage={'Nenhum registro encontrado'}>
          <Column field={'dia'} header={'Dia'} style={{ textAlign: 'center' }} />
          <Column
            field={'qte_total_veiculos_carregados'}
            header={'Qte Veículos Carregados'}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_veiculos_parados'}
            header={'Qte Veículos Parados'}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_veiculos_parados_mais_2dias'}
            header={'Parados + 2 dias'}
            style={tableCellCentered(200)}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default withRouter(EtapaEnvioRota)
